import React, { useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import rupiahFormat from "rupiah-format";
import NumberFormat from "react-number-format";
import { Row, Col, ListGroup } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { useTranslation } from "react-i18next";
import "../style.css";
import { Paper } from "@material-ui/core";
import { FeatureReport } from "./components/FeatureReport";

export const TransactionHistoryTab = () => {
  const [mdr, setMdr] = React.useState("");
  const [refresh, setRefresh] = React.useState(0);
  const handleRefresh = () => setRefresh((state) => state + 1);

  const [selectedOutlet, setSelectedOutlet] = React.useState({
    id: "",
    name: "All Outlet"
  });
  const [startDate, setStartDate] = React.useState(
    dayjs().format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = React.useState(dayjs().format("YYYY-MM-DD"));
  const [endDateFilename, setEndDateFilename] = React.useState("");
  const [startTime, setStartTime] = React.useState(new Date());
  const [endTime, setEndTime] = React.useState(new Date());
  const [tabData, setTabData] = React.useState({
    no: 5,
    table: "table-history-transaction",
    filename: `riwayat-transaksi_${startDate}-${endDateFilename}`
  });
  const [status, setStatus] = React.useState("");

  const [allTransactions, setAllTransactions] = React.useState([]);
  const [currency, setCurrency] = React.useState("");
  const handleCurrency = async () => {
    const API_URL = process.env.REACT_APP_API_URL;
    const userInfo = JSON.parse(localStorage.getItem("user_info"));

    const { data } = await axios.get(
      `${API_URL}/api/v1/business/${userInfo.business_id}`
    );

    // console.log("currency nya brpw", data.data.Currency.name)

    setCurrency(data.data.Currency.name);
  };
  React.useEffect(() => {
    handleCurrency();
  }, []);

  const { t } = useTranslation();
  const [reports, setReports] = useState([]);

  // console.log("data history", reports)

  const getTransactions = async (id, status, start_range, end_range) => {
    const API_URL = process.env.REACT_APP_API_URL;
    const outlet_id = id ? `&outlet_id=${id}` : "";
    const filter = status ? `&status=${status}` : "";

    if (start_range === end_range) {
      end_range = dayjs(end_range)
        .add(1, "day")
        .format("YYYY-MM-DD");
    }

    if (new Date(start_range) > new Date(end_range)) {
      start_range = dayjs(start_range)
        .subtract(1, "day")
        .format("YYYY-MM-DD");
      end_range = dayjs(end_range)
        .add(1, "day")
        .format("YYYY-MM-DD");
    }

    try {
      const { data } = await axios.get(
        `${API_URL}/api/v1/transaction/mdr?order=newest&per_page=999${outlet_id}&date_start=${start_range}&date_end=${end_range}${filter}`
      );

      setAllTransactions(data.data);
      const compileReports = data.data.map((item) => {
        return {
          date: dayjs(item.createdAt).format("DD-MM-YYYY HH:mm:ss"),
          receipt_id: item.receipt_id,
          payment_method: item.Payment?.Payment_Method?.name,
          status: item.status,
          outlet_name: item.Outlet?.name,
          user: item.User?.User_Profile?.name || "Guest",
          customer_phone_number: item.Customer_Profile?.phone_number || "-",
          customer_name: item.Customer_Profile?.name || "-",
          // sub_total: item.Payment?.amount,
          payment_tax: item.Payment?.payment_tax,
          payment_service: item.Payment?.payment_service,
          payment_total: item.Payment?.payment_total,
          payment_amount: item.Payment?.amount,
          items: item.Transaction_Items.map((val) => ({
            sales_type: val.Sales_Type?.name,
            sku: val.Product?.sku || "-",
            product_name: val.Product?.name || "-",
            category_name: val.Product?.Product_Category?.name || "-",
            quantity: val.quantity,
            price_product: val.price_product,
            addon_name: val.Transaction_Item_Addons.map(function(addon) {
              return addon.Addon?.name || "-"; // Jika tidak ada addon, ganti dengan "-"
            }),
            price_addons: val.Transaction_Item_Addons.map(function(addon) {
              return addon.price_addons || "-"; // Jika tidak ada addon, ganti dengan "-"
            }),
            group_name: val.Transaction_Item_Addons.map(function(addon) {
              return addon.Group_Addon?.name || "-"; // Jika tidak ada addon, ganti dengan "-"
            })
          }))
        };
      });

      setReports(compileReports.flat(1));
    } catch (err) {
      setAllTransactions([]);
      console.log(err);
    }
  };

  React.useEffect(() => {
    getTransactions(selectedOutlet.id, status, startDate, endDate);
    setTabData({
      ...tabData,
      filename: `riwayat-transaksi_${startDate}-${endDateFilename}`
    });
  }, [
    selectedOutlet,
    status,
    startDate,
    endDate,
    refresh,
    endDateFilename,
    mdr
  ]);

  const customStyles = {
    headRow: {
      style: {
        minHeight: "78px"
      }
    },
    rows: {
      style: {
        minHeight: "70px"
      }
    }
  };

  const columns = [
    {
      name: `${t("no")}`,
      selector: "no",
      sortable: true,
      width: "70px"
    },
    {
      name: `${t("receiptId")}`,
      selector: "receipt_id",
      sortable: true
    },
    {
      name: `${t("paymentMethod")}`,
      selector: "payment_method",
      sortable: true
    },
    {
      name: `${t("staffOnCharge")}`,
      selector: "staff_charge",
      sortable: true
    },
    {
      name: `${t("outletName")}`,
      selector: "outlet_name",
      sortable: true
    },
    {
      name: `${t("paymentTotal")}`,
      selector: "payment_total",
      sortable: true
    },
    {
      name: `${t("totalDiscount")}`,
      selector: "total_discount",
      sortable: true
    },
    {
      name: `${t("status")}`,
      selector: "status",
      sortable: true
    }
  ];

  const dataTransactions = () => {
    return allTransactions.map((item, index) => {
      return {
        id: item.id,
        no: index + 1,
        receipt_id: item.receipt_id,
        payment_method: item.Payment?.Payment_Method?.name,
        staff_charge: item.User ? item.User.User_Profile.name : "",
        // payment_total: <NumberFormat value={item.Payment?.payment_total || 0} displayType={'text'} thousandSeparator={true} prefix={currency} />,
        // total_discount: <NumberFormat value={item.Payment?.payment_discount || 0} displayType={'text'} thousandSeparator={true} prefix={currency} />,
        payment_total: (item.Payment?.payment_total || 0).toLocaleString(
          "id-ID"
        ),
        total_discount: (item.Payment?.payment_discount || 0).toLocaleString(
          "id-ID"
        ),
        outlet_name: item.Outlet?.name || "-",
        // created_at: dayjs(item.createdAt).format("DD-MM-YYYY HH:mm:ss"),
        status: item.status,
        items: item.Transaction_Items
      };
    });
  };

  // console.log("dataa transaa", dataTransactions)
  const ExpandableComponent = ({ data }) => {
    const head = [
      "Sales Type",
      "Product",
      "Addons",
      "Addons Price",
      "Quantity",
      "Price"
    ];
    const body = data.items.map((item, index) => {
      const addons = item.Transaction_Item_Addons?.map((val) => val.Addon.name);
      const addons_price = item.Transaction_Item_Addons?.map(
        (val) => val.price_addons
      );
      return [
        item.Sales_Type.name,
        item.Product?.name || "-",
        addons.join(","),
        (addons_price.join(",") || 0).toLocaleString("id-ID"),
        item.quantity,
        <NumberFormat
          value={item.price_product}
          displayType={"text"}
          thousandSeparator={true}
          prefix={currency}
        />
      ];
    });

    return (
      <>
        <ListGroup style={{ padding: "1rem", marginLeft: "1rem" }}>
          <ListGroup.Item>
            <Row>
              {head.map((item, index) => {
                return (
                  <Col key={index} style={{ fontWeight: "700" }}>
                    {item}
                  </Col>
                );
              })}
            </Row>
          </ListGroup.Item>
          {body.map((item, index) => {
            return (
              <ListGroup.Item key={index}>
                <Row>
                  {item.map((val, valIndex) => {
                    return <Col key={valIndex}>{val}</Col>;
                  })}
                </Row>
              </ListGroup.Item>
            );
          })}
        </ListGroup>
      </>
    );
  };

  const handleStartDate = (date) => setStartDate(date);
  const handleEndDate = (date) => setEndDate(date);
  const handleEndDateFilename = (date) => setEndDateFilename(date);
  const handleSelectedOutlet = (outlet) => setSelectedOutlet(outlet);
  const handleSelectStatus = (status) => setStatus(status.target.value);
  const handleTimeStart = (time) => setStartTime(time);
  const handleTimeEnd = (time) => setEndTime(time);
  const handleMdr = (params) => setMdr(params);

  return (
    <>
      <Row>
        <Col>
          <Paper elevation={2} style={{ padding: "1rem", height: "100%" }}>
            <FeatureReport
              handleStartDate={handleStartDate}
              handleEndDate={handleEndDate}
              tabData={tabData}
              handleMdr={handleMdr}
              handleEndDateFilename={handleEndDateFilename}
              handleSelectedOutlet={handleSelectedOutlet}
              titleReport="reportTransactionHistory"
              handleSelectStatus={handleSelectStatus}
              handleTimeStart={handleTimeStart}
              handleTimeEnd={handleTimeEnd}
              stateShowMdr={true}
            />
            <div style={{ display: "none" }}>
              <table id="table-history-transaction">
                <thead>
                  <tr>
                    <th>{t("salesTransactionReport")}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr></tr>
                </tbody>
                <thead>
                  <tr>
                    <th>{t("date")}</th>
                    <td>
                      {startDate} - {endDateFilename}
                    </td>
                  </tr>
                  <tr>
                    <th>{t("statusTransaksi")}</th>
                    <td>{status ? status : "Semua Transaksi"}</td>
                  </tr>
                  <tr>
                    <th>{t("products/Customers")}</th>
                    <td>{t("allCustomers")}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr></tr>
                </tbody>
                <thead>
                  <tr>
                    <th>{t("date&Time")}</th>
                    <th>{t("struckID")}</th>
                    <th>{t("paymentMethod")}</th>
                    <th>{t("paymentStatus")}</th>
                    <th>{t("outlet")}</th>
                    <th>{t("salesType")}</th>
                    <th>{t("user")}</th>
                    <th>{t("customerPhoneNumber")}</th>
                    <th>{t("customerName")}</th>
                    <th>{t("sku")}</th>
                    <th>{t("productName")}</th>
                    <th>{t("category")}</th>
                    <th>{t("productsAmount")}</th>
                    <th>{t("productPrice")}</th>
                    <th>{t("addonsType")}</th>
                    <th>{t("addons")}</th>
                    <th>{t("addonsPrice")}</th>
                    {/* <th>{t("subTotal")}</th> */}
                    <th>{t("paymentTax")}</th>
                    <th>{t("paymentService")}</th>
                    <th>{t("paymentTotal")}</th>
                    {/* <th>{t("paymentAmount")}</th> */}
                  </tr>
                </thead>
                <tbody>
                  {reports.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.date}</td>
                        <td>{item.receipt_id}</td>
                        <td>{item.payment_method}</td>
                        <td>{item.status}</td>
                        <td>{item.outlet_name}</td>
                        <td>
                          {item.items.find((product) => product.sales_type)
                            ?.sales_type || "-"}
                        </td>
                        <td>{item.user}</td>
                        <td>{item.customer_phone_number}</td>
                        <td>{item.customer_name}</td>
                        {/* <td>{item.items.find(product => product.sku)?.sku || "-"}</td> */}
                        <td>
                          {item.items.map((product) => product.sku).join(", ")}
                        </td>
                        <td>
                          {item.items
                            .map((product) => product.product_name)
                            .join(", ")}
                        </td>
                        <td>
                          {item.items
                            .map((product) => product.category_name)
                            .join(", ")}
                        </td>
                        <td>
                          {item.items
                            .map((product) => product.quantity)
                            .join(", ")}
                        </td>
                        <td>
                          {item.items
                            .map((product) => product.price_product)
                            .join(", ")}
                        </td>
                        <td>
                          {item.items
                            .map((product) => product.group_name)
                            .join(", ")}
                        </td>
                        <td>
                          {item.items
                            .map((product) => product.addon_name.join(", "))
                            .join(", ")}
                        </td>
                        <td>
                          {item.items
                            .map((product) => product.price_addons)
                            .join(", ")}
                        </td>
                        {/* <td>{item.payment_service}</td> */}
                        {/* <td>{item.sub_total}</td> */}
                        <td>{item.payment_tax}</td>
                        <td>{item.payment_service}</td>
                        <td>{item.payment_total}</td>
                        {/* <td>{item.payment_amount}</td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <DataTable
              noHeader
              pagination
              columns={columns}
              data={dataTransactions()}
              expandableRows
              expandableRowsComponent={ExpandableComponent}
              style={{ minHeight: "100%" }}
              noDataComponent={t("thereAreNoRecordsToDisplay")}
              customStyles={customStyles}
            />
          </Paper>
        </Col>
      </Row>
    </>
  );
};
